import React, { useState, useEffect, Fragment, useMemo } from "react";

import {
  useDeleteUserMutation,
  useLazyUpdateUserActiveGetQuery,
} from "../../../../../utils/customer/customerTaskTable";
import useRequireAuth from "../../../../../utils/useRequireAuth";
import useClickOutside from "../../../../../hooks/Screen/useClickOutside";
import DeleteIcon from "../../../../../assets/images/icons/deleteIcon";
import { ReactComponent as ProfileIconTie } from "../../../assets/profileIconTie.svg";
import Loader from "../../../../UniversalComponents/Loader";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../../../../utils/alertSlice";
import ReactTableComponent from "../../../../UniversalComponents/ReactTableComponentNewDesign";
import { getInitials, getPersonInitials, getTitleCase } from "../../../../../utils/utilityFunctions/stringUtility";
import UserNameHover from "../../../../User/UserNameHover";
import { hideLoader, showLoader } from "../../../../../utils/loaderSlice";
import { ReactComponent as NoUSerManagement } from "../../../../../assets/images/NoUserManagement.svg";
import { closeSideDrawer, openSideDrawer } from "../../../../../utils/permissionSlice";
import { fetchManagePermissionGroup } from "../../../../../utils/api/managePermissionApi";
import AvatarName from "../../../../UniversalComponents/AvatarName";
import { ReactComponent as DeleteSolidicon } from "../../../../../assets/images/NewDelete.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/images/icons/EditIconUserManagement.svg";
import { checkAccessPermission, getIsOwner } from "../../../../../utils/utilityFunctions/localServices";
import ConfirmationDialogMulti from "../../../../UniversalComponents/ConfirmationDialogMulti";
import HighlightedParagraph from "../../../../UniversalComponents/HighlightedParagraph";
import { useLocation, useSearchParams } from "react-router-dom";

const ManageAccess = ({ refetch }) => {
  const [quiFilter, setQuiFilter] = useState({ external: 0, status: 1 });
  const [loading, setLoading] = useState(false);
  const { token } = useRequireAuth();
  const [SelecteduserId, setSelecteduserId] = useState(null);
  const [editData, setEditData] = useState();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [isProfileView, setIsProfileView] = useState(false);
  const [newDialog, setNewDialog] = useState(false);
  const [showHoverId, setShowHoverId] = useState(null);
  const [openShowDetails, setOpenShowDetails] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isPermissionOpen, setIsPermissionOpen] = useState(false);
  const [userTableData, setUserTableData] = useState([]);
  const [keysArray, setKeysArray] = useState([]);
  const [showConfirmationBox, setShowConfirmationBox] = useState(false);
  const [confirmationText, setConfirmationText] = useState("This action will delete the user from all companies");
  const [deleteUserID, setDeleteUserID] = useState();
  const [userSearch, setUserSearch] = useState("");
  const keysToExclude = [
    "userId",
    "enabled_status",
    "manager_designation",
    "action",
    "useruuId",
    "reporting_uuid",
    "company",
    "emp_id",
    "mobile",
    "designation",
    "first_name",
    "last_name",
    "is_super_admin",
  ];
  const dispatch = useDispatch();
  const path = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const isAddUser = searchParams.get("user");

  useEffect(() => {
    if (isAddUser === "add") {
      handleAddUser();
    }
  }, [isAddUser]);

  const handleToggle = () => {
    setIsProfileView(!isProfileView);
  };

  // fetching data
  const getGroupPermissionData = async () => {
    try {
      const response = await fetchManagePermissionGroup({ query: { key: "all_users" } });
      if (response?.success) {
        setUserTableData(response?.data);
        setKeysArray(Object.keys(response?.data[0]));
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message, type: "danger" }));
    }
  };

  useEffect(() => {
    getGroupPermissionData();
  }, [refetch]);

  //update the active/inActive
  const [
    updateUserActive,
    { isLoading: isUpdating, isSuccess: isUpdateSuccess, isError: isUpdateError, error: updateError },
  ] = useLazyUpdateUserActiveGetQuery();

  useEffect(() => {
    handelsave();
  }, [quiFilter]);
  // const totalData = customerTableALL?.data?.total;

  const handleNavigate = (userData) => {
    setIsPopupOpen(true);
    setEditData(userData);
    // setSelecteduserId(userData.userUuid);
  };

  const handleNavigateMore = (...data) => {
    setEditData(data);
    setOpenShowDetails(true);
  };

  const createColumnDefinitions = (data, handleNavigate, handleNavigateMore) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.error("Invalid data provided");
      return [];
    }

    // Extract the first object
    const firstObject = data[0];

    // Get all keys and exclude the first and last keys
    //const keys = Object.keys(firstObject).slice(1, -1);
    const keys = Object.keys(firstObject)
      .filter((key) => !keysToExclude.includes(key))
      .slice(1);

    // console.log(keys, "keys");

    // Map over the keys to create column definitions
    return keys.map((key, index) => ({
      accessor_key: key,
      label: getTitleCase(key),
      ...((key === "name" || key === "reporting_manager") && {
        // callingFunction: handleNavigate,
        // tooltip: UserNameHover,
        toolTipHandler: handleNavigateMore,
        titleCase: true,
      }), // Add callingFunction only to the first column
    }));
  };

  const handleEditUser = (data) => {
    console.log(data, "rowdata");
    dispatch(openSideDrawer({ key: "CREATE_USER", data: { data } }));
  };

  const dynamicColums = keysArray
    ?.filter((key) => !keysToExclude.includes(key))
    .slice(1)
    ?.map((item, index) => {
      return {
        accessorKey: item,
        header: getTitleCase(item),
        cell: (info) => {
          const value = info.getValue();
          const rowData = info.row.original;
          const isSuperAdmin = rowData?.is_super_admin;
          if (item === "name") {
            return (
              <p className="flex items-center gap-2">
                <AvatarName name={getInitials(value)} bgColor={"#1D4469"} size="medium" />
                <HighlightedParagraph searchTerm={userSearch} paragraph={value} />
                {isSuperAdmin ? (
                  <div className="px-2 py-0.5 rounded-md bg-[#FFF] text-[#767676] border border-[#E9E9E9] flex items-center">
                    {" "}
                    <ProfileIconTie /> <span className="ml-2 text-[12px] font-400">Admin</span>{" "}
                  </div>
                ) : null}
              </p>
            );
          }
          if (item == "email") {
            return <HighlightedParagraph searchTerm={userSearch} paragraph={value} />;
          }
          if (item == "reporting_manager") {
            return <HighlightedParagraph searchTerm={userSearch} paragraph={value?.name} />;
          }

          if (item === "assigned_groups") {
            return (
              <div className="flex flex-wrap gap-2">
                {value.map((group, idx) => (
                  <div
                    key={idx}
                    className="bg-gray-100 text-gray-700 px-2 py-0.5 rounded-md text-sm border border-[#E9E9E9] min-w-[40px] text-center"
                  >
                    <HighlightedParagraph searchTerm={userSearch} paragraph={group?.group_name} />
                  </div>
                ))}
              </div>
            );
          }
        },
      };
    });

  // Adding Actions column at the end
  dynamicColums.push({
    accessorKey: "actions",
    header: "Actions",
    cell: ({ row }) => {
      const rowData = row.original;
      const isSuperAdmin = rowData?.is_super_admin;

      if (isSuperAdmin) return null; // Don't show actions for super admins

      return (
        <div className="flex gap-2 text-sm">
          <button
            className="text-[#1D4469] opacity-20 hover:opacity-100 transition-opacity duration-200 flex items-center gap-1"
            onClick={() => handleEditUser(rowData)}
          >
            <EditIcon /> Edit
          </button>
          {Boolean(getIsOwner()) && (
            <button
              className="text-red-600 opacity-20 hover:opacity-100 transition-opacity duration-200 flex items-center gap-1"
              // onClick={() => handleDeleteUser(rowData.user_id)}
              // onClick = {() => setShowConfirmationBox(true)}
              onClick={() => handleOpenConfirmationBox(rowData?.user_id)}
            >
              <DeleteSolidicon /> Delete
            </button>
          )}
        </div>
      );
    },
  });

  const ManageListHeader = createColumnDefinitions(userTableData, handleNavigate, handleNavigateMore);

  const closePopup = () => {
    setEditData();
    setIsEditPopupOpen(false);
    setIsPopupOpen(false);
    setNewDialog(false);
  };
  const handelsave = () => {
    // refetchCustomerData();
  };

  useEffect(() => {
    if (!isPopupOpen) {
      setIsHovered(false);
    }
  }, [isPopupOpen]);
  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const handleOpenNewDialog = () => {
    setNewDialog(true);
  };

  const ProfileOutSideClick = useClickOutside(() => {
    setIsEditPopupOpen(false);
  });

  // const handleToggleUserActive = async (data) => {
  //   // console.log(data?.userId, "vinaydata");

  //   try {
  //     await updateUserActive({ token, data: data?.userId });
  //     refetchCustomerData();
  //     dispatch(pushAlert({ message: "User updated successfully!", type: "success", visible: true }));
  //   } catch (err) {
  //     dispatch(pushAlert({ message: "Something went wrong.", type: "error", visible: true }));
  //   }
  // };

  const handleActiveChange = (e) => {
    setQuiFilter({ ...quiFilter, status: e.target.value });
  };

  const handleTypeChange = (e) => {
    setQuiFilter({ ...quiFilter, external: e.target.value });
  };

  const handleShowHover = (data, header) => {
    setShowHoverId({ data, header });
  };

  const handleShowDetails = (value, headerKey) => {
    setOpenShowDetails(value && { customerData: value, headerKey });
  };

  const isHoverDetailsOpen = (item, header) => {
    const customerIdMatches = showHoverId?.data?.customer_id?.value === item?.customer_id?.value;
    const headerKeyMatches = showHoverId?.header?.key === header?.key;

    return customerIdMatches && headerKeyMatches;
  };

  const handleEditModalClick = (userId) => {
    // setSelecteduserId(userId);
  };
  const closeUEPopup = () => {
    setSelecteduserId(null);
  };

  // useEffect(() => {
  //   if (isLoading) {
  //     dispatch(showLoader());
  //   } else {
  //     dispatch(hideLoader());
  //   }
  // }, [isLoading]);

  const handleAddUser = () => {
    dispatch(openSideDrawer({ key: "CREATE_USER", data: {} }));
  };

  const handleAddGroup = () => {
    dispatch(openSideDrawer({ key: "CREATE_GROUP", data: {} }));
  };

  const [DeleteUser, { isLoading: AddUpdateLoading, isError, isSuccess, error }] = useDeleteUserMutation();

  const handleOpenConfirmationBox = (userid) => {
    setShowConfirmationBox(true);
    setDeleteUserID(userid);
  };

  const handleDeleteUser = async (userId) => {
    const payload = { user_id: userId };
    try {
      const response = await DeleteUser({ token, data: payload }).unwrap();

      if (response?.success) {
        dispatch(
          pushAlert({ type: "success", message: response?.message || "User deleted successfully", visible: true })
        );
        getGroupPermissionData();
        setShowConfirmationBox(false);
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.message || "Something went wrong", visible: true }));
      }
    } catch (err) {
      dispatch(
        pushAlert({
          type: "danger",
          message: err?.data?.message || err?.error || "Failed to delete user",
          visible: true,
        })
      );
    }
  };

  const handleConfirmClick = () => {
    handleDeleteUser(deleteUserID);
  };

  return (
    <div className="flex flex-col gap-4 h-full justify-around ">
      {/* Heading and description */}
      <div className="mt-2 w-full max-md:max-w-full">
        <h2 className="text-lg font-medium tracking-wide text-primary max-md:max-w-full">User Permissions</h2>
        <p className="mt-2 text-sm text-neutral-500">Manage access levels and permissions for Users</p>

        {/* Search and action buttons */}
        <div className="flex flex-wrap gap-6 justify-between items-end mt-4 w-full max-md:max-w-full">
          <div className="flex gap-2 items-center px-2 py-1 text-sm rounded-md border border-gray-200 min-h-[39px] min-w-60 text-neutral-500 w-[300px]">
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/dac71522aa23d67d26ac9a353012590c427bbd43?placeholderIfAbsent=true&apiKey=461dd38d56414be9bb1e394424980cc1"
              className="object-contain aspect-square w-[18px]"
              alt="Search"
            />
            <input
              type="text"
              placeholder="Type name or Email"
              className="bg-transparent border-none outline-none flex-1"
              value={userSearch}
              onChange={(e) => setUserSearch(e.target.value)}
            />
          </div>
          <div className="items-center text-base font-medium text-cyan-900 ">
            {checkAccessPermission("Add & Manage Groups & Permission") && (
              <button
                onClick={handleAddUser}
                className="flex gap-2.5 items-center px-4 py-2 bg-white rounded-md border border-cyan-900"
              >
                Add User
              </button>
            )}
            {/* <button
              onClick={handleAddGroup}
              className="flex gap-2.5 items-center px-6 py-3 bg-white rounded-md border border-cyan-900"
            >
              Add Group
            </button> */}
          </div>
        </div>
      </div>

      {/* table */}
      <div className="flex flex-col gap-5 pt-2 grow min-h-0 h-full border-t border-l border-r rounded-md">
        <ReactTableComponent
          apiStates={{
            body: {
              // isLoading: isLoading,
              // isError: isUserDataError,
            },
          }}
          alternateDivs={{
            emptyData: (
              <div className="w-full h-full">
                <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                  <NoUSerManagement className="h-[300px] w-[300px]" />
                  <span className="text-14 text-black text-sm font-400 font-poppins ">
                    No User Management External User Data is Available.
                  </span>
                  {/* <span
                             onClick={() => openPopup()}
                             className="border px-5 py-1  bg-white cursor-pointer items-center text-center text-base font-medium  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-md shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
                           >
                             + Add Service
                           </span> */}
                </div>
              </div>
            ),
          }}
          tablename={"All Users"}
          headers={ManageListHeader}
          isRawColumns={dynamicColums}
          body={userTableData}
          isProfilePodToolTip={true}
          refetchprofilePodTable={handelsave}
          onRowClick={(data) => console.log("userID kl", data)}
          actionColumn={(item) => {
            // console.log("Itme itme item", item);
            return (
              <div
                // className={m-1}
                key={item?.id}
                className="flex items-center"
              >
                <button className={`ms-3`} title="Edit" onClick={() => handleEditModalClick(item?.user.uuId)}>
                  <i className="bi bi-pencil"></i>
                </button>
                <button onClick={() => console.log(item)} className="ml-2 pt-2">
                  <DeleteIcon color={"red"} size={22} />
                </button>
              </div>
            );
          }}
          disableSearchIcon
          disableFilterIcon
          externalGlobalFilter={userSearch}
          setExternalGlobalFilter={setUserSearch}
        />
      </div>

      <ConfirmationDialogMulti
        open={showConfirmationBox}
        onConfirm={() => handleConfirmClick()}
        onClose={() => setShowConfirmationBox(false)}
        // title={viewToDelete?.view_name ? "Delete View Confirmation" : "Discard?"}
        message={confirmationText}
        confirmVariant={"delete"}
        confirmText={"Delete"}
        cancelText={"No"}
        iconVariant={"delete"}
      />
    </div>
  );
};
export default ManageAccess;
